import {View} from "react-native";
import * as React from "react";

export const TransparentBox = ({children, marginBottom}) => <View
    style={{borderRadius: 15, backgroundColor: 'rgba(0,0,0,0.3)', padding: 20, paddingTop: 5, marginBottom: marginBottom}}>{children}</View>